import { render } from "./base.vue?vue&type=template&id=1eef96aa&scoped=true"
import script from "./base.vue?vue&type=script&lang=js"
export * from "./base.vue?vue&type=script&lang=js"

import "./base.vue?vue&type=style&index=0&id=1eef96aa&lang=scss&scoped=true"

import exportComponent from "D:\\codes\\chat28\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eef96aa"]])

export default __exports__